import Axios from "axios";
import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { transform } from "typescript";
import config from "../../config";
import { IHolder, ITransaction } from "../../interfaces";
import { arrayToFormData } from "../../utils/functions";
import CoreComponent from "../CoreComponent";

interface IState {
    holder: IHolder,
    isLoading: boolean,
    limit: number,
    year: number,
    pagination: any,
    isTransactionsLoading: boolean,
    transactions: ITransaction[],
    currency: number,
    currentPage: number,
    last_transaction: ITransaction
}

class Balance extends CoreComponent<any, IState> {

    state: IState = {
        holder: null,
        isLoading: false,
        year: null,
        limit: 30,
        isTransactionsLoading: false,
        transactions: [],
        pagination: null,
        currency: undefined,
        currentPage: 1,
        last_transaction: null
    }

    async componentWillMount() {
        this.loadBalance();
        this.loadTransactions();
    }

    async loadBalance() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;

            url = `${config.api}/transactions/current-balance`;

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    holder: res.data.user,
                    isLoading: false,
                    last_transaction: res.data.last_transaction
                })
            }
        })
    }

    showMore() {
        this.setState({
            currentPage: this.state.currentPage + 1
        }, () => {
            this.loadTransactions();
        });
    }


    async loadTransactions() {
        this.setState({
            isTransactionsLoading: true,
        }, async () => {
            let url = null;
            let limit = this.state.limit * this.state.currentPage;

            url = `${config.api}/transactions/my-transactions?limit=${limit}`;

            if (this.state.year) {
                url += `&year=${this.state.year}`;
            }

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    transactions: res.data.transactions,
                    isTransactionsLoading: false,
                    pagination: res.data.pagination,
                    year: res.data.year
                });
            }
        })
    }

    years() {
        let years = [];

        for (let i = 2019; i <= new Date().getFullYear(); i++) {
            years.push(<option value={i} key={i}>{i}</option>);
        }

        return years;
    }

    async handleSubmit() {
        if (this.state.currency > 0 && this.state.currency <= Number.parseFloat(this.state.holder.balance)) {

            if (confirm("Подтвердите запрос")) {
                let res = await Axios.post(`${config.api}/transactions/request`, arrayToFormData({ currency: this.state.currency }));

                if (res.data.status == "success") {
                    this.setState({
                        currency: undefined
                    }, () => {
                        this.loadBalance();
                    });
                }

                toast(res.data.message, { type: res.data.status });
            }
        } else {
            toast("Запрос на вывод не должен превышать текущий баланс.", { type: "error" });
        }
    }

    render() {
        let { auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="riz-riz-mobi__balance">
                <div className="wrapper">
                    <div className="riz-mobi__balance-cover">
                        <span className="riz-mobi__balance-title">Баланс</span>
                        <div className="riz-mobi__content-cover">
                            <span className="riz-mobi__content">
                                <span className="riz-mobi__content-title">Доступно</span>
                                <span className={"riz-mobi__content-price " + (Number.parseFloat(this.state.holder?.balance) > 0 ? "text-green" : "")}>$ {Number.parseFloat(this.state.holder?.balance.toString()).toFixed(3).slice(0, -1)}</span>
                            </span>
                            {/* <span className="riz-mobi__content">
                                <span className="riz-mobi__content-title">В ожидании</span>
                                <span className="riz-mobi__content-price">$ {Number.parseFloat(this.state.holder?.waiting.toString()).toFixed(3).slice(0, -1)}</span>
                            </span> */}
                            <span className="riz-mobi__content">
                                <span className="riz-mobi__content-title">Оплачено</span>
                                <span className="riz-mobi__content-price">$ {Number.parseFloat(this.state.last_transaction ? this.state.last_transaction.currency.toString() : "0").toFixed(3).slice(0, -1)}</span>
                            </span>
                        </div>
                    </div>
                    {/* <div className="riz-mobi__balance-cover">
                        <span className="riz-mobi__balance-title">Вывод</span>
                        <form className="riz-mobi__form" onSubmit={(e: any) => {
                            e.preventDefault();

                            this.handleSubmit();
                        }}>
                            <input type="number" placeholder="$" name="currency" value={this.state.currency} onChange={(e: any) => {
                                this.setState({
                                    currency: e.target.value ? Number.parseFloat(e.target.value) : undefined
                                })
                            }} />
                            <button type="submit">Запросить</button>
                        </form>
                    </div> */}

                    <div className="riz-mobi__balance-cover">
                        <div className="riz-mobi__title-cover">
                            <span className="riz-mobi__balance-title">Транзакции</span>
                            {/* <select name="years" id="years" value={this.state.year} onChange={(e: any) => {
                                this.setState({ year: Number.parseInt(e.target.value) }, () => {
                                    this.loadTransactions();
                                });
                            }}>
                                {this.years()}
                            </select> */}
                        </div>

                        <table className="riz-mobi__table w-100">
                            <thead>
                                <tr>
                                    <th>Дата</th>
                                    <th>Сумма</th>
                                    {/* <th>Способ оплаты</th>
                                    <th>Статус</th> */}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {!this.state.isTransactionsLoading && this.state.transactions.length == 0 && <tr><td colSpan={4}>{("Ничего не найдено")}</td></tr>}
                                {this.state.isTransactionsLoading && <tr><td colSpan={11}>{("Загрузка данных")}</td></tr>}
                                {this.state.transactions.map((transaction: ITransaction, index: number) => {
                                    return (
                                        <tr key={index}>
                                            <td>{transaction.date}</td>
                                            <td className={transaction.type != 2 ? "price-success" : "price-danger"}>$ {(transaction.type != 2 ? "+" : "-") + (Number.parseFloat(transaction.currency.toString()).toFixed(3).slice(0, -1))}</td>
                                            {/* <td>
                                                {transaction.name}
                                            </td>
                                            <td>{transaction.type == 2 ? transaction.typeName : transaction.place}</td> */}
                                            <td>
                                                {transaction.type == 2 ? <a role="button" style={{ textDecoration: "underline" }} className="btn btn-info" onClick={() => {
                                                    alert(transaction.comment + ". Код транзакции: " + transaction.code);
                                                }}>Описание</a> : <a role="button" style={{ textDecoration: "underline" }} className="btn btn-info" onClick={() => {
                                                    alert("Площадка: " + transaction.place + ". Комментарии: " + transaction.comment);
                                                }}>Описание</a>}
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className="text-center p-3">
                            {this.state.transactions.length > 0 && this.state.transactions.length < (this.state.pagination?.totalCount) && <a role="button" className="spec-color fs-12" onClick={() => {
                                this.showMore();
                            }}>Показать ещё...</a>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(Balance);